import { InfractionResponse } from '../helpers/types';
import api from './api';

export function getSapTransportData(InfractionId: string | number, callback: (data: InfractionResponse) => void) {
  api
    .get(`/sap/transports/infraction/${InfractionId}`)
    .then((result: InfractionResponse) => {
      callback(result);
    })
    .catch((error: any) => {
      console.log('Error fetching SAP transport data: ', error);
    });
}
